import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import DiscrepancySearchField from "@tKgpco/Widgets/DiscrepancyHistory/DiscrepancySearchField";
import RMASearchField from "@tKgpco/Widgets/RMAHistory/RMASearchField";
import * as React from "react";

export const poNumberStyles: SearchTextFieldStyles = {};
const styles = poNumberStyles;

const RMASearchFieldOrderNumber: React.FunctionComponent<WidgetProps> = () => {
    return (
        <RMASearchField
            styles={styles}
            parameterField="orderNumber"
            label="Order #"
            inputType="text"
            placeholder=""
            testSelector="rma_filterOrderNumber"
        />
    );
};

const widgetModule: WidgetModule = {
    component: RMASearchFieldOrderNumber,
    definition: {
        group: "Common",
        displayName: "RMA Order Number",
    },
};

export default widgetModule;
